import {Component, Input} from '@angular/core';
import {EMPTY, Observable, OperatorFunction, UnaryFunction} from 'rxjs';
import {catchError, debounceTime, switchMap, tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MarkantElementsModule} from '@markant/elements-angular';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-continuous-action',
  templateUrl: './continuous-action.component.html',
  styleUrls: ['./continuous-action.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule],
})
export class ContinuousActionComponent {
  @Input() sticky = true;
  constructor(private readonly snackBar: MatSnackBar) {}

  updating = false;

  private preAction<T>(time: number): OperatorFunction<T, T> {
    return (a: Observable<T>) =>
      a.pipe(
        tap(() => (this.updating = true)),
        debounceTime(time),
      );
  }

  private postAction<T>(): OperatorFunction<T, T> {
    return (a: Observable<T>) => a.pipe(tap(() => (this.updating = false)));
  }

  /** This method requires some explanation. First of all note that the type signatures is the one from the switchMap operator. This is not
   * a coincidence. In fact, you can use it as a replacement for switchMap with the additional benefit that it updates
   * the state of this component accordingly.
   */
  public actions<T, O>(
    request: UnaryFunction<T, Observable<O>>,
    handleError: (error: unknown) => void = () => {
      this.snackBar.open(`Es ist ein Fehler aufgetreten. (Zeitpunkt: ${new Date()})`, 'Schließen', {duration: 5000});
    },
    time = 500,
  ): OperatorFunction<T, O> {
    return (observable) =>
      observable.pipe(
        this.preAction(time),
        switchMap((data) =>
          request(data).pipe(
            catchError((err) => {
              this.updating = false;
              handleError(err);
              return EMPTY;
            }),
          ),
        ),
        this.postAction(),
      );
  }
}
